import React, { useContext, useRef, useState, useEffect } from "react";
import { Form, Row, Col, Container, Button } from "react-bootstrap";
import FloatingLabel from "react-bootstrap/FloatingLabel";
import ReactPhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import es from "react-phone-input-2/lang/es.json";
//import "./css/FormDatosContacto.css";

import cloneDeep from "lodash/cloneDeep";

import { Titulo, Cargando, llamarApi, excepcionVacia, logger } from "./Comun";

import Contexto from "./Contexto";

const FormDatosContacto = (props) => {
  const parametros = useContext(Contexto);

  const [citaEsParaContactoLocal, setCitaEsParaContactoLocal] = useState(
    props.citaEsParaContacto
  );

  const handleChangeCitaEsParaContacto = (e) => {
    props.setCitaEsParaContacto(e.target.value);
    setCitaEsParaContactoLocal(e.target.value);
  };
  const handleChangeNombrePaciente = (e) => {
    props.setNombrePaciente(e.target.value);
  };
  const handleChangeApellidosPaciente = (e) => {
    props.setApellidosPaciente(e.target.value);
  };
  const handleChangeNombreContacto = (e) => {
    props.setNombreContacto(e.target.value);
  };

  const handleChangeApellidosContacto = (e) => {
    props.setApellidosContacto(e.target.value);
  };

  const [telefonoContactoLocal, setTelefonoContactoLocal] = useState(
    props.telefonoContacto
  );

  const [esPrimeraVezLocal, setEsPrimeraVezLocal] = useState(
    props.esPrimeraVez
  );

  const [telefonoValido, setTelefonoValido] = useState(true);
  const [esPrimeraVezInvalido, setEsPrimeraVezInvalido] = useState(false);

  const handleChangeTelefonoContacto = (value, data, event, formattedValue) => {
    checkTelefonoValido(telefonoContactoLocal);
    props.setTelefonoContacto(value);
    setTelefonoContactoLocal(value);
  };

  const handleChangeEmailContacto = (e) => {
    props.setEmailContacto(e.target.value);
  };

  const handleChangeEsPrimeraVez = (e) => {
    props.setEsPrimeraVez(e.target.value);
    setEsPrimeraVezLocal(e.target.value);
    setEsPrimeraVezInvalido(false);
  };

  const [submitEnEjecucion, setSubmitEnEjecucion] = useState(false);
  const [validated, setValidated] = useState(false);

  const formRef = useRef(null);

  function checkTelefonoValido(value, forzarValidacion) {
    const sanitizedPhone =
      "+" + (value ?? "").replace(/[\s\-\(\)\.]/g, "").trim();

    if (
      forzarValidacion ||
      (formRef.current && formRef.current.classList.contains("was-validated"))
    ) {
      const input = formRef.current.querySelector("#telefono_contacto");

      if (sanitizedPhone.match(/^\+[1-9]{1}[0-9]{10,19}$/)) {
        input.classList.remove("is-invalid");
        input.classList.remove("form-control");
        input.classList.add("is-valid");
        input.classList.add("form-control");

        setTelefonoValido(true);
        return true;
      } else {
        input.classList.remove("is-valid");
        input.classList.add("is-invalid");
        setTelefonoValido(false);

        return false;
      }
    } else {
      setTelefonoValido(true);
      return true;
    }
  }

  const handleClickSubmitFormContacto = (e) => {
    e.currentTarget.blur(); // Previene que el foco baje de nuevo al boton (por si hay error, que vaya al error)

    checkTelefonoValido(telefonoContactoLocal, true);

    const form = formRef.current;
    let formIsValid = form.checkValidity() && telefonoValido;

    // Si ya tiene valor, que lo ponga como válido
    setEsPrimeraVezInvalido(esPrimeraVezLocal === null);
    setValidated(true);

    if (!formIsValid) {
      let excepcionFormDatos = cloneDeep(excepcionVacia);

      excepcionFormDatos.continuarEnPagina = true;
      excepcionFormDatos.excepcionConocida = true;
      excepcionFormDatos.mensajeExcepcion =
        "Alguno de los datos introducidos no es válido. Por favor, revisa los campos resaltados";
      excepcionFormDatos.tipoExcepcion = "E";

      props.setExcepcion(excepcionFormDatos);
    } else {
      logger(
        new Date().getHours() +
          ":" +
          new Date().getMinutes() +
          "." +
          new Date().getSeconds() +
          "- Render del form de confirmar sesion"
      );

      if (submitEnEjecucion) return;
      setSubmitEnEjecucion(true);

      const urlAPI = parametros.urlBaseApis + "cs";

      const formData = new FormData(formRef.current);

      llamarApi({
        url: urlAPI,
        jwt: props.jwt,
        method: "POST",
        payload: {
          idSolicitudSesion: props.idSolicitudSesion,
          nombrePaciente: formData.get("nombre_paciente"),
          apellidosPaciente: formData.get("apellidos_paciente"),
          nombreContacto: formData.get("nombre_contacto"),
          apellidosContacto: formData.get("apellidos_contacto"),
          telefonoContacto: formData.get("telefono_contacto"),
          emailContacto: formData.get("email_contacto"),
          esPrimeraVez: formData.get("es_primera_vez"),
        },
        onSuccess: (data) => {
          props.setJwt(data.jwt);
          props.setDatosSolicitudSesionRegistrada(data.datosSolicitud);
          props.irAPAso("CSS");
          props.setExcepcion(excepcionVacia);
        },
        onError: (err) => {
          props.setExcepcion(err);
        },
        onFinally: () => setSubmitEnEjecucion(false),
      });
    }
  };

  const handleClickOtroHorario = () => {
    props.setHorarioSeleccionado(null); //Para que se llame a la lista de horarios y se borre la solicitud anterios
    props.irAPAso("LHD");
  };

  return (
    <>
      <Titulo textoTitulo="Introduce los datos de contacto para la cita"></Titulo>
      <Container className=" align-items-left pb-4 px-2">
        <Form ref={formRef} noValidate validated={validated}>
          <Form.Group controlId="cita_es_para_contacto_si">
            <Form.Label>¿La cita es para tí, o para otra persona?</Form.Label>
            <Form.Check
              name="cita_es_para_contacto"
              id="cita_es_para_contacto_si"
              type="radio"
              required
              className="ms-3"
              label="Para mí"
              value="1"
              onChange={handleChangeCitaEsParaContacto}
              defaultChecked={props.citaEsParaContacto !== "0"}
            ></Form.Check>
          </Form.Group>
          <Form.Group className="mb-4" controlId="cita_es_para_contacto_no">
            <Form.Check
              name="cita_es_para_contacto"
              id="cita_es_para_contacto_no"
              type="radio"
              className="ms-3"
              label="Para otra persona"
              value="0"
              onChange={handleChangeCitaEsParaContacto}
              defaultChecked={props.citaEsParaContacto === "0"}
            ></Form.Check>
          </Form.Group>

          <Form.Group controlId="nombre_paciente">
            {citaEsParaContactoLocal === "0" ? (
              <Form.Label>Nombre y apellidos del paciente</Form.Label>
            ) : (
              <Form.Label>Nombre y apellidos</Form.Label>
            )}

            <Form.Control
              type="text"
              name="nombre_paciente"
              required
              minLength="3"
              maxLength="45"
              placeholder={
                citaEsParaContactoLocal === "0"
                  ? "Nombre del paciente"
                  : "Nombre"
              }
              onChange={handleChangeNombrePaciente}
              defaultValue={props.nombrePaciente}
            />
            <Form.Control.Feedback type="invalid">
              {citaEsParaContactoLocal === "0"
                ? "Por favor, introduce el nombre del paciente (mínimo 3 letras)"
                : "Por favor, introduce tu nombre (mínimo 3 letras)"}
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group className="mb-4" controlId="apellidos_paciente">
            <Form.Control
              type="text"
              name="apellidos_paciente"
              className="mt-2"
              required
              minLength="3"
              maxLength="90"
              placeholder={
                citaEsParaContactoLocal === "0"
                  ? "Apellidos del paciente"
                  : "Apellidos"
              }
              onChange={handleChangeApellidosPaciente}
              defaultValue={props.apellidosPaciente}
            />
            <Form.Control.Feedback type="invalid">
              {citaEsParaContactoLocal === "0"
                ? "Por favor, introduce los apellidos del paciente (mínimo 2 letras)"
                : "Por favor, introduce tus apellidos (mínimo 2 letras)"}
            </Form.Control.Feedback>
          </Form.Group>

          {citaEsParaContactoLocal === "0" && (
            <>
              <Form.Group controlId="nombre_contacto">
                <Form.Label>
                  Nombre y apellidos de la persona de contacto
                </Form.Label>
                <Form.Control
                  type="text"
                  name="nombre_contacto"
                  placeholder="Nombre de la persona de contacto"
                  required
                  minLength="3"
                  maxLength="45"
                  onChange={handleChangeNombreContacto}
                  defaultValue={props.nombreContacto}
                />
                <Form.Control.Feedback type="invalid">
                  Por favor, introduce el nombre de la persona de contacto
                  (mínimo 3 caracteres)
                </Form.Control.Feedback>
              </Form.Group>

              <Form.Group className="mb-4" controlId="apellidos_contacto">
                <Form.Control
                  type="text"
                  name="apellidos_contacto"
                  className="mt-2"
                  placeholder="Apellidos de la persona de contacto"
                  required
                  minLength="2"
                  maxLength="90"
                  onChange={handleChangeApellidosContacto}
                  defaultValue={props.apellidosContacto}
                />
                <Form.Control.Feedback type="invalid">
                  Por favor, introduce los apellidos de la persona de contacto
                  (mínimo 2 caracteres)
                </Form.Control.Feedback>
              </Form.Group>
            </>
          )}
          <Form.Group className="mb-4" controlId="telefono_contacto">
            <Form.Label>Teléfono de contacto</Form.Label>
            <div className="input-group">
              <ReactPhoneInput
                localization={es}
                country={"mx"}
                preferredCountries={["mx"]}
                placeholder="Introduzca telefono del contacto"
                enableSearch={true}
                countryCodeEditable={false}
                onChange={handleChangeTelefonoContacto}
                searchPlaceholder="Buscar país"
                searchNotFound="País no encontrado"
                inputClass={`${telefonoValido ? "is-valid" : "is-invalid"}`}
                value={telefonoContactoLocal}
                inputProps={{
                  type: "text",
                  name: "telefono_contacto",
                  required: true,
                  id: "telefono_contacto",
                }}
              />
            </div>
            {!telefonoValido && (
              <div className="invalid-feedback invalid-feedback-visible">
                Por favor, introduce el teléfono de contacto
              </div>
            )}
          </Form.Group>
          <Form.Group className="mb-4" controlId="email_contacto">
            <Form.Label>Email de contacto</Form.Label>
            <Form.Control
              type="email"
              name="email_contacto"
              required
              maxLength="120"
              placeholder="Introduzca email del contacto"
              onChange={handleChangeEmailContacto}
              defaultValue={props.emailContacto}
            />
            <Form.Control.Feedback type="invalid">
              Por favor, introduce el email de contacto
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group controlId="es_primera_vez_si">
            <Form.Label>¿Es la primera vez que vienes a la clínica?</Form.Label>
            <Form.Check
              type="radio"
              required
              name="es_primera_vez"
              id="es_primera_vez_si"
              className="ms-3"
              label="Sí"
              value="1"
              isInvalid={esPrimeraVezInvalido}
              onChange={handleChangeEsPrimeraVez}
              defaultChecked={props.esPrimeraVez === "1"}
            ></Form.Check>
          </Form.Group>
          <Form.Group className="mb-4" controlId="es_primera_vez_no">
            <Form.Check
              type="radio"
              name="es_primera_vez"
              id="es_primera_vez_no"
              className="ms-3"
              label="No"
              value="0"
              isInvalid={esPrimeraVezInvalido}
              onChange={handleChangeEsPrimeraVez}
              defaultChecked={props.esPrimeraVez === "0"}
            ></Form.Check>
            {esPrimeraVezInvalido && (
              <div className="invalid-feedback d-block">
                Por favor, selecciona si es la primera vez que vienes a la
                clínica
              </div>
            )}
          </Form.Group>
          <Row className="w-100 justify-content-center text-center">
            <Col xs={12} sm={12} md={12} lg={12}>
              <Button
                onClick={handleClickSubmitFormContacto}
                className="px-3 mx-2"
              >
                Confirmar solicitud
              </Button>
              <Button
                onClick={handleClickOtroHorario}
                className="px-3 mx-2"
              >
                Seleccionar otro horario
              </Button>
            </Col>
          </Row>
        </Form>

        <Cargando
          mensaje="Registrando la solicitud de cita ..."
          visible={submitEnEjecucion}
        ></Cargando>
      </Container>
    </>
  );
};

export default FormDatosContacto;
